import { render } from "./BotaoCadastrar.vue?vue&type=template&id=980a22d0&ts=true"
import script from "./BotaoCadastrar.vue?vue&type=script&lang=ts"
export * from "./BotaoCadastrar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__